import React from "react";
import "./GetMusicOnOnkyo.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnOnkyo = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music release",
    "Select Onkyo Music Distribution",
    "Music delivered to Hi-Fi ecosystem",
    "Reach premium audio listeners",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>Onkyo Music Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music to Onkyo Hi-Fi audio platforms worldwide with FT Tunes and reach premium listeners."
        />

        <meta
          name="keywords"
          content="Onkyo music distribution, Onkyo HiFi music, distribute music Onkyo"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="onkyo-page">

        {/* HERO */}
        <section className="onkyo-hero">
          <Container>

            <img
              src="/Images/onkyo-logo.png"
              alt="Onkyo"
              className="onkyo-logo"
            />

            <h1>Distribute Your Music on Onkyo</h1>

            <p>
              Deliver studio-quality sound experiences by distributing your music
              to Onkyo’s premium Hi-Fi audio ecosystem worldwide.
            </p>

            <Button
              className="gradient-btn-onkyo"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Distribution
            </Button>

          </Container>

          <div className="hero-glow-onkyo"></div>
        </section>


        {/* SHOWCASE */}
        <section className="onkyo-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach High-Fidelity Music Lovers</h2>

                <p>
                  Onkyo devices deliver exceptional audio quality.
                  Get your music heard by audiophiles across premium
                  sound systems and connected entertainment platforms.
                </p>

                <Button
                  className="outline-btn-onkyo"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-onkyo.png"
                  alt="Onkyo Distribution"
                  className="onkyo-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="onkyo-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-onkyo">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="onkyo-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute on Onkyo
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-onkyo">
                  <h5>Hi-Fi Audio Quality</h5>
                  <p>Lossless listening experience.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-onkyo">
                  <h5>Premium Audience</h5>
                  <p>Audiophile listener base.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-onkyo">
                  <h5>Global Reach</h5>
                  <p>Connected smart audio devices.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-onkyo">
                  <h5>Revenue Tracking</h5>
                  <p>Monitor performance & earnings.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="onkyo-cta">
          <Container>

            <h2>Start Your Onkyo Music Distribution Today</h2>

            <Button
              className="gradient-btn-onkyo big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnOnkyo;